module.exports = __webpack_public_path__ + "img/NF.77b61038.svg";